import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getChainTypeOptions } from '../../../helpers/chainType';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { AddonProduct, ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorImageItem,
  SelectorItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  option: string,
  stainlessSteelChainAddonProduct: AddonProduct[],
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (
  chainType,
  stainlessSteelChainAddonProduct,
  send,
) => () => {
  let stainlessSteelChainPrice = 0,
    stainlessSteelChain = 0;

  if (chainType === 'Stainless Steel') {
    stainlessSteelChainPrice =
      stainlessSteelChainAddonProduct[0].variants[0].price;
    stainlessSteelChain = stainlessSteelChainAddonProduct[0].variants[0].id;
  }

  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      chainType,
      stainlessSteelChain,
      stainlessSteelChainPrice,
    },
  });
};

export const ChainType = () => {
  const [state, send] = useService(productBuilderMachine);
  const productType = getBaseProductType(state.context);
  const {
    stainlessSteelChain: stainlessSteelChainAddonProduct,
    custom: { chainType },
  } = state.context;
  const chainTypeOptions = getChainTypeOptions(state.context);
  if (isCurrentState('chainType', state) && chainTypeOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Chain Type</Heading>
      <Selector
        isSlider={true}
        isSingleOption={chainTypeOptions.length === 1 ? true : false}
      >
        {chainTypeOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'chainType',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === chainType}
              onClick={onClick(option, stainlessSteelChainAddonProduct, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
